let baseURL = {
  apiURL: 'https://apiadmin.777gametest.com',
}
export default baseURL
